import {showErrorNotification, showSuccessNotification} from '../../global/notifications';
import {closeKendoWindow, openCloseWindow, openKendoWindow, windowTriggers} from '../../global/kendoWindows';
import {
    answerChangedEvent,
    clearChangeIndicator,
    invoiceInit,
    setPriorInvoiceWindowData,
    setTitle,
    showLoaders,
    setOverrideData
} from './all';
import corporateQuestions, {saveCorporateQuestions} from './corporate-questions'
import getBodySettings from '../../global/page-settings';
import multipleAttachmentSetup from '../../attachments/multiple-attachments';
import projectManagerList, {showNoApprovals, getNoApprovals, approveNothingEvent} from "./project-manager-list";
import _bundle from '../../../core/core--bundles';

const {nameArea, nameController, nameAction, namePage} = getBodySettings('page');

let qid = 0;
let pmNumber = 0;
let isTopList = false;
let activeTab = 'Incomplete';
let firstTopLoad = true;

const messages = {
    GoodsReceived: "Latest Goods Received Date not clearly reflected",
    GoodsDate: "Latest Goods Received Date After Year End",
    ReflectedAmount: "",
    DollarAmountInput: "Accrual Amount already included in posted invoices",
    AlreadyPosted: 'Accrual Amount already included in posted invoices',
    DollarVariance: 'Accrual Amount Variance >= $5,000',
    PercentageComplete: "PercentageComplete"
}


export default function (k_quarterSelect, k_pmSelect) {
    attachApplyFilterEvent(k_quarterSelect, k_pmSelect);
    k_quarterSelect.dataSource.bind('requestEnd', e => {
        if (e.response.length > 1) {
            qid = e.response[1].qid;
            k_quarterSelect.value(qid);
            loadMaterialAccrual();
        }
        k_pmSelect.dataSource.read();
    });

    _bundle.add({
        name: 'Accruals: Page Update',
        event: ['on:PageUpdate'],
        fn() {
            const approvalSection = $('#approvals');
            if(activeTab === 'Incomplete' && !isTopList ) {
                approvalSection.hide();
            } else{
                getNoApprovals().then(() => {
                    showNoApprovals();
                    approveNothingEvent();
                });
                approvalSection.show();
            }
        }
    });

    _bundle.add({
        name: 'Accruals: Change Tabs',
        event: ['on:TabChange'],
        fn() {
            activeTab = $('.menu-topbar__link.--active').text();
            const $applyFilterButton = $('#js-accrual-filter');
            $applyFilterButton.trigger('click');
        }
    });
    
}

const attachApplyFilterEvent = (k_quarterSelect, k_pmSelect) => {
    let $applyFilterButton = $('#js-accrual-filter');

    if ($applyFilterButton.length) {
        $applyFilterButton.on('click', function () {
            showLoaders();
            qid = k_quarterSelect.value();
            pmNumber = k_pmSelect.value();
            loadMaterialAccrual();
        });
    }
};

function bindGridEvents() {
    const invoiceGrids = $('.invoiceGrid');
    
    if(invoiceGrids.length) {
        invoiceGrids.each(function() {
            const g = $(this).data('kendoGrid');
            g.bind('dataBound', function(e) {
                const commentBtns = e.sender.element.find('[data-kendoWindow="invoiceComment"]');
            });
        });
    }
    
}

export const loadMaterialAccrual = (accrualToReopen) => {
    let rx = `/Account/Accruals/MaterialAccrualData?qid=${qid}&pm=${pmNumber}&status=${activeTab}`;
    isTopList = pmNumber === '0' || pmNumber === 0;
    let rxCallback;
    if(!isTopList) {
        rxCallback = function () {
            setPriorInvoiceWindowData();
            setTitle('', false);
            invoiceInit();
            attachSaveEvent();
            attachApprovalEvent();
            attachRejectionEvent();
            answerChangedEvent();
            addNewLadingNumber();
            attachDeleteLadingNumberEvent();
            reopenAccrual(accrualToReopen);
            multipleAttachmentSetup();
            attachReviewResetEvent();
            setWindowData();
            setOverrideData();
            $(document).trigger('on:PageUpdate');
        };
    }
    if (isTopList) {
        rx = `/Account/Accruals/MaterialAccrualOverview?qid=${qid}`;
        rxCallback = function () {
            setPriorInvoiceWindowData();
            setTitle('Top Ten', true);
            invoiceInit();
            corporateQuestions(qid);
            attachApprovalEvent();
            attachRejectionEvent();
            reopenAccrual(accrualToReopen);
            $(document).trigger('on:PageUpdate');
            projectManagerList();
        }
    }

    $('#projectManager').data('kendoDropDownList').dataSource.read();
    $('.js-accrual-section').load(rx, rxCallback);
};

const gridChanged = (grid) => {
    const ds = grid.dataSource;
    let dirty = false;

    $.each(ds._data, function () {
        if (this.dirty === true) dirty = true;
    });
    if (ds._destroyed.length > 0) dirty = true;

    return dirty;
};

const attachSaveEvent = () => {
    let $saveButtons = $('[data-role="save"]');

    if ($saveButtons.length) {
        $saveButtons.on('click', function () {
            let $form = $(this).closest('form'),
                accrualId = $form.data('accrual-id'),
                serializedData = $form.serialize(),
                invoiceGrid = $('#invoiceList' + accrualId).data('kendoGrid');
            $.post(`/Account/Accruals/SaveAccrual?${serializedData.split(`${accrualId}=`).join('=')}`, function (response) {
                if (response === 'SUCCESS') {
                    reloadBillOfLading(accrualId)
                        .then(() => {
                            showSuccessNotification('Accrual Info Saved');
                            clearChangeIndicator();
                        });
                } else {
                    showErrorNotification(response);
                }
            });
            if (invoiceGrid.dataSource.hasChanges()) {
                const invData = {};
                const invoices = [];

                invData.qid = qid;
                $.each(invoiceGrid._data, function () {
                    if (this.dirty) {
                        const invoice = {};
                        invoice.ResponsibleParty = this.ResponsibleParty;
                        invoice.InvoiceNumber = this.InvoiceNumber;
                        invoice.Included = this.Included;
                        invoice.InvoiceAmount = this.InvoiceAmount;
                        invoices.push(invoice);
                    }
                });
                invData.invoices = invoices;
                $.post('/Account/Accruals/MaterialInvoiceUpdate', invData, function (r) {
                    invoiceGrid.dataSource.read();
                });
            }
        });
    }
};

export const attachApprovalEvent = () => {
    let $approvalButtons = $('[data-role="approve"]');
    if ($approvalButtons.length) {
        $approvalButtons.on('click', function (e) {
            let $self = $(this),
                $form = $(this).closest('form'),
                accrualId = $form.data('accrual-id'),
                approvalAs = $self.data('approve-as'),
                $pin = $self.parent().parent().find(`#pin_id_${approvalAs}`),
                data = {
                    qid: qid,
                    role: approvalAs,
                    pin: $pin.val(),
                    pmNumber: pmNumber === 0 || pmNumber === '0' ? accrualId : pmNumber
                };

            if (isTopList) {
                saveCorporateQuestions($self)
                    .then(() => approveMaterialAccrual(data))
                    .then(() => {
                        loadMaterialAccrual(accrualId);
                    })
                    .catch((error) => {
                        showErrorNotification(error);
                    });
            } else {
                approveMaterialAccrual(data)
                    .then(() => {
                        loadMaterialAccrual(accrualId);
                    })
                    .catch((error) => {
                        showErrorNotification(error);
                    });
            }
        });
    }
};

const approveMaterialAccrual = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Account/Accruals/MaterialApproval', data, function (response) {
            if (response === true) {
                resolve();
            } else {
                reject(response);
            }
        });
    })
}

const attachRejectionEvent = () => {
    let $rejectButton = $('[name=rejectApprovals]');

    if ($rejectButton.length) {
        if (pmNumber === '0' || pmNumber === 0) {
            $rejectButton.on('click', function () {
                let $self = $(this),
                    $form = $self.closest('form'),
                    accrualId = $form.data('accrual-id'),
                    data = {
                        accrualId: accrualId,
                        type: namePage
                    };

                $.post('/Account/Accruals/RejectCorporateQuestions', data, function (response) {
                    if (response === true) {
                        loadMaterialAccrual(accrualId);
                    } else {
                        showErrorNotification('Failed to Reject Approvals');
                    }
                });
            })
        } else {
            $rejectButton.on('click', function () {
                let $self = $(this),
                    $form = $self.closest('form'),
                    accrualId = $form.data('accrual-id');
                let data = {
                    qid: qid,
                    pmNumber: pmNumber
                };

                $.post('/Account/Accruals/MaterialRejection', data, function (response) {
                    if (response === true) {
                        loadMaterialAccrual(accrualId);
                    } else {
                        showErrorNotification('Failed to Reject Approvals');
                    }
                });
            })
        }
    }
};

const attachReviewResetEvent = () => {
    let $rejectButton = $('#resetReviewer');

    if ($rejectButton.length) {
        $rejectButton.on('click', function () {
            let $self = $(this),
                $form = $self.closest('form'),
                accrualId = $form.data('accrual-id'),
                data = {
                    qid: qid,
                    pmNumber: pmNumber
                };

            $.post('/Account/Accruals/ResetMaterialReviewer', data, function (response) {
                if (response === true) {
                    loadMaterialAccrual(accrualId);
                } else {
                    showErrorNotification('Failed to Reset Reviewer');
                }
            });
        })
    }
}

const addNewLadingNumber = () => {
    let $addButton = $('[id^=AddNewBillOfLadingNumber]')

    if ($addButton.length) {
        $addButton.on('click', function (e) {
            e.preventDefault();
            let $form = $(this).closest('form'),
                accrualId = $form.data('accrual-id'),
                $billDiv = $form.find('.js-bill-div'),
                $billParent = $billDiv.parent(),
                $template = $($('#billTemplate').html()),
                $billId = $template.find('[name=BillID]'),
                $billDeleted = $template.find('[name=BillDeleted]'),
                $billNumber = $template.find('[name=BillNumber]'),
                $billDate = $template.find('[name=BillDate]'),
                itemCount = $billDiv.length;

            //Bill Id
            $billId.attr('name', `BillOfLadingNumberList[${itemCount}].Id${accrualId}`);

            //Bill Delete
            $billDeleted.attr('name', `BillOfLadingNumberList[${itemCount}].Deleted${accrualId}`);

            //Bill Number
            $billNumber.addClass('k-textbox --changed');
            $billNumber.attr('name', `BillOfLadingNumberList[${itemCount}].LadingNumber${accrualId}`);

            //Bill Date
            $billDate.addClass('--changed');
            $billDate.attr('name', `BillOfLadingNumberList[${itemCount}].BillDate${accrualId}`);
            $billDate.kendoDatePicker();

            //Append to list
            $billParent.append($template);

            attachDeleteLadingNumberEvent();
        });
    }
}

const attachDeleteLadingNumberEvent = () => {
    let $deleteButton = $('.js-number-div .k-icon.k-i-delete');

    if ($deleteButton.length > 1) {
        $deleteButton.unbind('click');
        $deleteButton.on('click', function () {
            let $container = $(this).parents('.js-bill-div');

            //Hide Container
            $container.hide();
            // Mark for deletion
            $container.find('[name*=Deleted]').val(true);
        })
    }
}

const reloadBillOfLading = (accrualId) => {
    return new Promise((resolve, reject) => {
        $(`form[data-accrual-id=${accrualId}]`).find('.js-bill-lading-reload').load('/Account/Accruals/ReloadBillOfLadingNumbers', {accrualId: accrualId}, function () {
            resolve();
        });
    });
}

const reopenAccrual = (accrualId) => {
    if (accrualId) {
        $(`[id=Id${accrualId}]`).parents('li.soxexc').find('span.k-link.soxexc__toggle').click()
    }
}

const setWindowData = () => {
    let $modalButton = $('[data-kendoWindow="ChangeOrderWindow"]');
    if ($modalButton.length) {
        $modalButton.on('click', function () {
            let $changeOrderWindow = $('#ChangeOrderWindow'),
                $self = $(this);
            $changeOrderWindow.data('purchase-order', $self.data('purchase-order'));
        });
    }
}